export default "__VITE_ASSET__BgKm7W4F__"